import React, { useEffect } from 'react';
import WarningMessage from '../../_utils/warning-message';

const wmbAccountOrgCheckUrl = '/__check_incomplete_wmb_user_account';
const pollingIntervals = 10000;

export default function IncompleteWmbAccountMessage({
  loginOrgUrl,
  handleWalmartBusinessOrgLoginMessage,
}) {
  useEffect(() => {
    const restricted = fetchRestriction();

    if (!restricted) {
      handleWalmartBusinessOrgLoginMessage(false);
      return;
    }

    const pollTimeout = window.setInterval(checkUserAccount, pollingIntervals);

    async function checkUserAccount() {
      try {
        const restricted = await fetchRestriction();

        if (!restricted) {
          handleWalmartBusinessOrgLoginMessage(false);
          window.clearInterval(pollTimeout);
        }
      } catch (e) {
        window.clearInterval(pollTimeout);
      }
    }

    async function fetchRestriction() {
      const response = await fetch(wmbAccountOrgCheckUrl);
      const { wmb_user_account_incomplete = true } = await response.json();

      if (!response.ok) {
        return true;
      }

      return wmb_user_account_incomplete;
    }
  }, []);

  const openUrlInNewPopupWindow = function () {
    window.open(
      loginOrgUrl,
      '_blank',
      [
        'alwaysRaised=1',
        'height=600',
        'location=0',
        'menubar=0',
        'personalbar=0',
        'status=0',
        'toolbar=0',
        'width=800',
      ].join(','),
    );
  };

  return (
    <WarningMessage hidePrefix dataTestId="imcomplete-wmb-message">
      To proceed with Checkout, please finish creating your Walmart Business
      account by telling us about your organization.{' '}
      <a href="#" onClick={openUrlInNewPopupWindow}>
        Create free account
      </a>
    </WarningMessage>
  );
}
